import { normalizeDepartmentId } from '../utils/normalizeIds';
import { REQUIRED_NURSING_CHARTS } from './compliance_constants';
import { DEFAULT_NURSING_LAYOUT_TITLES } from './crossAuditSlot';

/**
 * Home wards that submit nurse_notes without ตรวจไขว้ (cross-audit) charts.
 * Progress and minimum chart counts use own-chart slots only (5), not the full 8.
 */
export const NURSING_NO_CROSS_AUDIT_DEPARTMENT_IDS = ['G10'] as const;

/** Own-chart slots in the default nursing layout (รายโรค x3 + โรคทั่วไป x2). */
export const NURSING_OWN_CHART_SLOT_COUNT = DEFAULT_NURSING_LAYOUT_TITLES.filter(
  (title) => !title.includes('ตรวจไขว้'),
).length;

export function departmentRequiresNursingCrossAudit(
  departmentId: string | null | undefined,
): boolean {
  const normalized = normalizeDepartmentId(departmentId ?? '');
  if (!normalized) return true;
  return !NURSING_NO_CROSS_AUDIT_DEPARTMENT_IDS.some(
    (id) => normalizeDepartmentId(id) === normalized,
  );
}

export function getRequiredNursingChartSlots(
  departmentId: string | null | undefined,
): number {
  if (!departmentRequiresNursingCrossAudit(departmentId)) {
    return NURSING_OWN_CHART_SLOT_COUNT;
  }
  return REQUIRED_NURSING_CHARTS;
}

export function getDefaultNursingChartCountForDepartment(
  departmentId: string | null | undefined,
): number {
  return getRequiredNursingChartSlots(departmentId);
}

export function getDefaultNursingLayoutTitlesForDepartment(
  departmentId: string | null | undefined,
): readonly string[] {
  const count = getDefaultNursingChartCountForDepartment(departmentId);
  return DEFAULT_NURSING_LAYOUT_TITLES.slice(0, count);
}
